import { render, staticRenderFns } from "./WebhookUpdated.vue?vue&type=template&id=892ebcde"
import script from "./WebhookUpdated.vue?vue&type=script&lang=js"
export * from "./WebhookUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports